import { render } from "./OrderItem.vue?vue&type=template&id=082f4ba9&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=082f4ba9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082f4ba9"]])

export default __exports__